import * as yup from 'yup'

import { EMAIL_REGEX } from 'src/constants'

export const SignInSchema = yup.object({
  email: yup
    .string()
    .required('email-required')
    .matches(EMAIL_REGEX, 'invalid-email'),
  password: yup
    .string()
    .required('password-required')
    .min(8, 'pass-min-8-chars')
    .matches(/[a-z]+/, 'one-lowercase')
    .matches(/[A-Z]+/, 'one-uppercase')
    .matches(/\d+/, 'one-number'),
})

export const SignInDefaultValues = {
  email: '',
  password: '',
}
